import loadable from '@/components/common/Loadable';

const LuckyPage = loadable(() => import('@/games/pages/Lucky'));
const DT20Page = loadable(() => import('@/games/pages/DT20'));
const DT6Page = loadable(() => import('@/games/pages/DT6'));
const DTL20Page = loadable(() => import('@/games/pages/DTL20'));
const Lucky15Page = loadable(() => import('@/games/pages/Lucky15'));
const AAAPage = loadable(() => import('@/games/pages/AAA'));
const BTablePage = loadable(() => import('@/games/pages/BTable'));
const Teen42Page = loadable(() => import('@/games/pages/Teen42'));
const Card32Page = loadable(() => import('@/games/pages/Card32'));
const AB4Page = loadable(() => import('@/games/pages/AB4'));
const AB20Page = loadable(() => import('@/games/pages/AB20'));
const ABJPage = loadable(() => import('@/games/pages/ABJ'));
const RoulettePage = loadable(() => import('@/games/pages/Roulette'));
const UniqueRoulettePage = loadable(() => import('@/games/pages/UniqueRoulette'));
const ThreeCardJPage = loadable(() => import('@/games/pages/ThreeCardJ'));
const Joker1Page = loadable(() => import('@/games/pages/Joker1'));
const Joker20Page = loadable(() => import('@/games/pages/Joker20'));
const PokerPage = loadable(() => import('@/games/pages/Poker'));
const Poker6Page = loadable(() => import('@/games/pages/Poker6'));
const LottCardPage = loadable(() => import('@/games/pages/LottCard'));
const GoalPage = loadable(() => import('@/games/pages/Goal'));
const SuperOverPage = loadable(() => import('@/games/pages/SuperOver'));
const CricketV3Page = loadable(() => import('@/games/pages/CricketV3'));
const CMeter1Page = loadable(() => import('@/games/pages/CMeter1'));
const SicBoPage = loadable(() => import('@/games/pages/SicBo'));
const Race17Page = loadable(() => import('@/games/pages/Race17'));
const Race2Page = loadable(() => import('@/games/pages/Race2'));
const Race20Page = loadable(() => import('@/games/pages/Race20'));
const QueenPage = loadable(() => import('@/games/pages/Queen'));
const MogamboPage = loadable(() => import('@/games/pages/Mogambo'));
const BaccaratPage = loadable(() => import('@/games/pages/Baccarat'));
const TrioPage = loadable(() => import('@/games/pages/Trio'));
const BallByBallPage = loadable(() => import('@/games/pages/BallByBall'));
const TeensinPage = loadable(() => import('@/games/pages/Teensin'));
const Patti2Page = loadable(() => import('@/games/pages/Patti2'));
const TrapPage = loadable(() => import('@/games/pages/Trap'));
const DoliDanaPage = loadable(() => import('@/games/pages/DoliDana'));
const PoisonPage = loadable(() => import('@/games/pages/Poison'));
const Teen6Page = loadable(() => import('@/games/pages/Teen6'));
const Teen32Page = loadable(() => import('@/games/pages/Teen32'));
const Teen9Page = loadable(() => import('@/games/pages/Teen9'));
const Teen8Page = loadable(() => import('@/games/pages/Teen8'));
const TeenMufPage = loadable(() => import('@/games/pages/TeenMuf'));
const Teen20Page = loadable(() => import('@/games/pages/Teen20'));
const TeenPage = loadable(() => import('@/games/pages/Teen'));
const TeenUniquePage = loadable(() => import('@/games/pages/TeenUnique'));
const NoteNumPage = loadable(() => import('@/games/pages/NoteNum'));
const CMatch20Page = loadable(() => import('@/games/pages/CMatch20'));
const Dum10Page = loadable(() => import('@/games/pages/Dum10'));
const Teen120Page = loadable(() => import('@/games/pages/Teen120'));
const Teen1Page = loadable(() => import('@/games/pages/Teen1'));

export const GAME_REGISTRY: Record<string, React.ComponentType> = {
  lucky5: LuckyPage, // done and tested
  lucky7: LuckyPage, // done and tested
  lucky7eu: LuckyPage, // done and tested
  lucky7eu2: LuckyPage, // done and tested
  dt20: DT20Page, // done and tested
  dt202: DT20Page, // done and tested
  dt6: DT6Page, // done and tested
  dtl20: DTL20Page, // done and tested
  lucky15: Lucky15Page, // done and tested
  aaa: AAAPage, // done and tested
  aaa2: AAAPage, // done and tested
  btable: BTablePage, // done and tested
  btable2: BTablePage, // done and tested
  card32: Card32Page, // done and tested
  card32eu: Card32Page, // done and tested
  poker: PokerPage, // done and tested
  poker20: PokerPage, // done and tested
  poker6: Poker6Page, // done and tested
  goal: GoalPage, // done and tested
  goal2: GoalPage, // done and tested
  cmeter1: CMeter1Page, // done and tested
  queen: QueenPage, // done and tested
  mogambo: MogamboPage, // done and tested
  trio: TrioPage, // done and tested
  ballbyball: BallByBallPage, // done and tested
  race17: Race17Page, // done and tested
  race20: Race20Page, // done and tested
  race2: Race2Page, // done and tested
  teen6: Teen6Page, // tested; suit/odd-even/rank side bets cannot be placed (backend contract needed)
  teen32: Teen32Page, // done and tested
  teen33: Teen32Page, // done and tested
  teen3: Teen32Page, // done and tested
  teenmuf: TeenMufPage, // done and tested
  teen42: Teen42Page, // done and tested
  teen41: Teen42Page, // done and tested
  teen20: Teen20Page, // done and tested
  teen20b: Teen20Page, // done and tested
  teen20c: Teen20Page, // done and tested
  teen9: Teen9Page, // done and tested
  teen8: Teen8Page, // done and tested
  superover: SuperOverPage, // done and tested
  superover2: SuperOverPage, // done and tested
  superover3: SuperOverPage, // done and tested
  cricketv3: CricketV3Page, // done and tested; scorecard backend dependency
  teen: TeenPage, // tested; Odd/Even bets send the same request (backend contract needed)
  teenunique: TeenUniquePage, // done and tested
  joker1: Joker1Page, // done and tested
  joker120: Joker1Page, // done and tested
  joker20: Joker20Page, // done and tested
  /* -----------------------------------------------------*/
  ab4: AB4Page, // done and tested
  ab3: AB4Page, // done and tested
  ab20: AB20Page, // done and tested
  '3cardj': ThreeCardJPage, // done and tested
  abj: ABJPage, // done and tested
  lottcard: LottCardPage, // done and tested
  sicbo: SicBoPage, //done and tested
  sicbo2: SicBoPage, //done and tested
  baccarat: BaccaratPage, //done and tested
  baccarat2: BaccaratPage, //done and tested
  teensin: TeensinPage, //done and tested
  roulette11: RoulettePage, //Some ui doubt and result is coming late
  roulette12: RoulettePage, //Some ui doubt and result is coming late
  roulette13: RoulettePage, // back only
  ourroullete: UniqueRoulettePage, // d247 slug spelling; inside bets matched by row id
  patti2: Patti2Page, //done and tested
  trap: TrapPage, // done and tested
  poison: PoisonPage, //done and tested
  poison20: PoisonPage, //done and tested
  notenum: NoteNumPage, //done and tested
  cmatch20: CMatch20Page, //Data is not  proper result is differernt from d247
  dum10: Dum10Page, // done and tested
  teen120: Teen120Page, //done and tested
  teen1: Teen1Page, //done and tested
  dolidana: DoliDanaPage, // done and tested
};
